
export default {
    
    setDatepickerOpen: async ({state, commit, dispatch}, str) => {

        commit("setDatepickerOpen", str)
        
        commit("setPackagesMobileDropdownOpen", false)
        commit("setParticipantsDropdownOpen", false)
        commit("setSelectDropdownOpen_prestId", {id:'', current_select_location:''})
        if (!str) {
            commit("setBodyOverflowHidden", false)
        }
        if (str && state.screenType==='mobile') {
            commit("setBodyOverflowHidden", true)
        }
    },


    setParticipantsDropdownOpen: ({state, commit}, bool) => {
        commit("setParticipantsDropdownOpen", bool)

        commit("setPackagesMobileDropdownOpen", false)
        commit("setDatepickerOpen", '')
        commit("setSelectDropdownOpen_prestId", {id:'', current_select_location:''})
        if (!bool) {
            commit("setBodyOverflowHidden", false)
        }
        if (bool && state.screenType==='mobile') {
            commit("setBodyOverflowHidden", true)
        }
    },


    setPackagesMobileDropdownOpen: ({commit}, bool) => {
        commit("setPackagesMobileDropdownOpen", bool)

        commit("setParticipantsDropdownOpen", false)
        commit("setDatepickerOpen", '')
        commit("setSelectDropdownOpen_prestId", {id:'', current_select_location:''})

        if (bool) {
            commit("setBodyOverflowHidden", true)
        } else {
            commit("setBodyOverflowHidden", false)
        }
    },
    
    setSelectDropdownOpen_prestId: ({commit}, obj) => {
        commit("setSelectDropdownOpen_prestId", obj)

        commit("setDatepickerOpen", '')
        commit("setPackagesMobileDropdownOpen", false)
        commit("setParticipantsDropdownOpen", false)
    },

}